<template>
   <div class="row">
     <div class="col-md-12">
       <h3>iKids Report</h3>
       <hr>
       <div class="form-inline" v-if="meta.is_active">
         <label class="mr-2">Filter Class</label>
         <select
           class="form-control"
           v-model="meta.is_active"
           @change="loadIsActive"
         >
           <option value="2">Show All</option>
           <option value="1">Show Only Active</option>
           <option value="0">Show Only Inactive</option>
         </select>
         
       </div>
     </div>
     <div class="col-md-12 mb-2 mt-2">
       <div class="form-inline">
         <label class="mr-4">Showing</label>
         <select
           class="form-control"
           v-model="meta.per_page"
           @change="loadPerPage"
         >
           <option value="10">10</option>
           <option value="25">25</option>
           <option value="50">50</option>
           <option value="100">100</option>
         </select>
         <label class="ml-2">Entries</label>
       </div>
     </div>
 
     <div class="col-md-12">
       <CDataTable
         sorter
         striped
         hover
         bordered
         :items="items"
         :fields="fields"
         :sort-by.sync="sortBy"
         :sort-desc.sync="sortDesc"
         show-empty
       >
       </CDataTable>
     </div>
   </div>
 </template>
 
 <script>
 import _ from "lodash";
 import moment from "moment";
 import service from "@/services/service";
 import axios from "axios";
 import store from "@/store.js";
 
 export default {
   name: "Table",
   props: {
     items: Array,
     caption: {
       type: String,
       default: "Table",
     },
     hover: Boolean,
     striped: Boolean,
     bordered: Boolean,
     small: Boolean,
     fixed: Boolean,
     dark: Boolean,
     items: {
       type: Array,
       required: true,
     },
     fields: {
       type: Array,
       required: true,
     },
     meta: {
       required: true,
     },
     btn_show: {
       required: true,
     },
     btn_edit: {
       required: true,
     },
     btn_deactivate: {
       required: true,
     },
     btn_reactivate: {
       required: true,
     },
     btn_destroy: {
       required: true,
     },
     is_uuid: {
       required: true,
     },
   },
   data() {
     return {
       sortBy: null,
       sortDesc: false,
       deleteModal: false,
       selected: null,
       selectID: null,
       inc: 5,
     };
   },
   watch: {
     sortBy(val) {
       this.$emit("sort", {
         sortBy: this.sortBy,
         sortDesc: this.sortDesc,
       });
     },
     sortDesc(val) {
       this.$emit("sort", {
         sortBy: this.sortBy,
         sortDesc: this.sortDesc,
       });
     },
   },
   methods: {
     getPhoto(data) {
       if (data) {
         return axios.defaults.baseURL + "/getfile/memberphoto/" + data;
       } else {
         return axios.defaults.baseURL + "/getfile/memberphoto/no_photo.jpg";
       }
     },
     openURL(data) {
       this.$router.push({ name: "Detail Kids", query: { id: data } });
     },
 
     loadPerPage(val) {
       this.$emit("per_page", this.meta.per_page);
     },
 
     loadIsActive(val) {
       this.$emit("is_active", this.meta.is_active);
     },
 
     changePage(val) {
       this.$emit("pagination", val);
     },
 
     show: function(id) {
       this.$emit("show", id);
     },
 
     edit: function(id) {
       this.$emit("edit", id);
     },
 
     deactivate: function(id) {
       this.$emit("deactivate", id);
     },
 
     reactivate: function(id) {
       this.$emit("reactivate", id);
     },
 
     destroy: function(id) {
       this.$emit("destroy", id);
     },
 
     resetpassword: function(id) {
       this.$emit("resetpassword", id);
     },
 
     grantwebaccess: function(id) {
       this.$emit("grantwebaccess", id);
     },
 
     converttomember: function(id) {
       this.$emit("converttomember", id);
     },
 
     frontEndDateFormat: function(date) {
       return moment(date, "YYYY-MM-DD").format("DD MMMM YYYY");
     },
   },
 };
 </script>
 